import { mapper } from '@maia/icons';
import { CartItem, Typography } from '@maia/ui';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { getCancellationQuestionsOptions } from '../../../../features/cancel-insurance/get-questions/queryOptions';
import { getCustomerOptions } from '../../../../features/customer/customer/queryOptions';
import { CustomerInformation } from '../../../../features/shared/customer/customer-information';
import { getInsuranceOptions } from '../../../../features/insurance/insurance/queryOptions';

export const Route = createFileRoute(
  '/_authenticated/cancel-insurance/$customer/cart/$cart/insurance/$insurance/_layout',
)({
  component: RouteComponent,
  loader: async ({
    context: { queryClient },
    params: { customer: customerGuid, cart, insurance: insuranceGuid },
  }) => {
    const questions = await queryClient.ensureQueryData(
      getCancellationQuestionsOptions({
        cancellationGuid: cart,
        insuranceGuid: insuranceGuid,
        customerGuid: customerGuid,
      }),
    );

    const customer = await queryClient.ensureQueryData(
      getCustomerOptions(customerGuid),
    );

    const insurance = await queryClient.ensureQueryData(
      getInsuranceOptions(insuranceGuid),
    );

    return {
      questions,
      customer,
      insurance,
    };
  },
});

function RouteComponent() {
  const { customer, insurance } = Route.useLoaderData();

  return (
    <div className="layout-sidebar">
      <Outlet />

      <div className="flex flex-col gap-y-32 area-page-sidebar">
        <Typography
          variant="display6"
          weight="medium"
          className="text-primaryMain"
        >
          Verzekering opzeggen
        </Typography>
        <CustomerInformation customer={customer} />
        <CartItem
          name={insurance.title}
          icon={mapper(insurance.icon)}
          specs={insurance.specs
            .filter((s) => s.value)
            .map((s) => ({
              title: s.label,
              description: s.value,
            }))}
          billingUnit={customer.billingUnit}
        />
      </div>
    </div>
  );
}
